import { TIENDA } from "../data/config";

// Construye una URL valida de WhatsApp con un mensaje codificado.
export const construirUrlWhatsApp = (mensaje) => {
  const texto = encodeURIComponent(mensaje);
  return `https://wa.me/${TIENDA.whatsappNumero}?text=${texto}`;
};

// Hook utilitario para abrir conversaciones de WhatsApp desde cualquier
// componente. Devuelve una funcion que abre la URL en una pestana nueva.
export const useWhatsApp = () => {
  const abrirWhatsApp = (mensaje) => {
    const url = construirUrlWhatsApp(mensaje);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return { abrirWhatsApp };
};
